import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { themeName } from '../Enums/enums.enum';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private activeThem = new BehaviorSubject(themeName.Default);
  
  getActiveTheme() {
    return this.activeThem.asObservable();
  }

  setActiveThem(name) {
    this.activeThem.next(name);
  }
}
